import React from "react";
import { Layout, Notification } from "react-admin";
import MyMenu from "./Menu";
import AppBar from './AppBar';

const MyLayout = props => <Layout {...props} menu={MyMenu} appBar={AppBar} />;

export default MyLayout;
